import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 py-14 text-center text-blue-100/80 sm:px-6" data-id="element-97" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl" data-id="element-98" data-mp="3gg0xbxz0nnv0">
        <p className="font-display text-xl font-extrabold text-gold-soft" data-id="element-99" data-mp="32nul2myzi10u">LIBROFY.STORE™</p>
        <p className="mx-auto mt-4 max-w-xl text-[15px]" data-id="element-100" data-mp="32m1cv38q38qq">
          El sistema N°1 de automatización profesional para agentes de seguros independientes de
          Argentina.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[15px] text-blue-100/70" data-id="element-101" data-mp="3ucxndx7b91au">
          Porque vender seguros no debería costarte todos los domingos de tu vida.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-102" data-mp="3ldkeb5n3meqn">
          <span data-id="element-103" data-mp="3qc3yp1m1nigw">📧 hola@librofy.store</span>
          <span data-id="element-104" data-mp="29z6tyark0hfd">📲 @librofy.store</span>
          <span data-id="element-105" data-mp="29y5gy0qz9kv0">🌐 www.librofy.store</span>
        </div>

        <p className="mx-auto mt-8 max-w-lg border-t border-white/10 pt-8 text-[15px] italic text-blue-100/70" data-id="element-106" data-mp="2eya05yj9stox">
          “El próximo domingo a las 11 de la noche puede ser diferente.” — Librofy.store
        </p>

        <p className="mt-6 text-xs text-blue-200/50" data-id="element-107" data-mp="3gapdlka06mgi">
          © Librofy™ 2024 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}